import React, { useEffect, useState } from 'react'
import { INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import { useSelector } from 'react-redux';
import HttpAPICall from '../../../services/HttpAPICall';
import { DisplayListPagination } from '../../../components/TapUi';
import Loader from '../../../components/ui/Loader/Loader';
import TapIcon from '../../../services/TapIcon';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

function ProcurementTab(props) {

    const indentUrl =   INVENTORY_API_BASE_URL_2 + "/warehouse_indent";
    const requisitionUrl =   INVENTORY_API_BASE_URL_2 + "/requisition";
    const poUrl     =   INVENTORY_API_BASE_URL_2 + "/purchase_order";

    const {ticketData , subAssemblyId}  =   props;
     const permissions = useSelector(state => state.app.acl_info && state.app.acl_info.permissions ? state.app.acl_info.permissions : []);

    const accessToken = useSelector(state => state.auth.access_token)
    const settings = useSelector(state => state.app.setting)

    const [indentData, setIndentData] = useState({
        loading : false,
        data : [],
        metaData : null,
        totalListingCount : 0
    }); 

    const [prData, setPrData] = useState({
        loading : false,
        data : [],
        metaData : null,
        totalListingCount : 0
    }); 

    const [poData, setPoData] = useState({
        loading : false,
        data : [],
        metaData : null,
        totalListingCount : 0
    }); 


    useEffect(() => {
        getIndentList()
        getPrList()
        getPoList()
    }, [])


    const getIndentList = (page = 1) => {
        setIndentData(pre => ({...pre, loading : true}))
        let params = {
          page: page,
          search_ticket_id: ticketData ? ticketData.activity_id : '',
          search_sub_assembly_id : subAssemblyId ? subAssemblyId?.enc_id : ""

        };
        HttpAPICall.withAthorization("GET", indentUrl, accessToken, params, {}, (resp) => {
            let respData = resp.data;
            setIndentData(pre => ({
                ...pre,
                data : respData.data,
                metaData : respData.meta,
                totalListingCount: respData.meta.total
            }))
        }).then(() => setIndentData(pre => ({...pre, loading : false})));
    };

    const getPrList = (page = 1) => {
        setPrData(pre => ({...pre, loading : true}))
        let params = {
          page: page,
          search_ticket_id: ticketData
            ? ticketData.activity_id
            : '',
            search_sub_assembly_id : subAssemblyId ? subAssemblyId?.enc_id : ""
        };
        HttpAPICall.withAthorization("GET", requisitionUrl, accessToken, params, {}, (resp) => {
            let respData = resp.data;
            setPrData(pre => ({
                ...pre,
                data : respData.data,
                metaData : respData.meta,
                totalListingCount: respData.meta.total
            }))
        }).then(() => setPrData(pre => ({...pre, loading : false})));
    };

    const getPoList = (page = 1) => {
        setPoData(pre => ({...pre, loading : true}))
        let params = {
          page: page,
          search_ticket_id: ticketData
            ? ticketData.activity_id
            : '',
            search_sub_assembly_id : subAssemblyId ? subAssemblyId?.enc_id : ""
        };
        HttpAPICall.withAthorization("GET", poUrl, accessToken, params, {}, (resp) => {
            let respData = resp.data;
            let listPayload = respData && respData.list ? respData.list : respData;
            let metaData = listPayload && listPayload.meta ? listPayload.meta : (listPayload && listPayload.current_page ? listPayload : null);
            let warehouses = respData && respData.warehouses && respData.warehouses.length > 0 ? respData.warehouses : [];
            let statusList = respData && respData.status && respData.status.length > 0 ? respData.status : [];
            let rows = listPayload && listPayload.data && listPayload.data.length > 0 ? listPayload.data : [];
            let normalizedRows = rows.map((row) => {
                let warehouseData = row.warehouse ? row.warehouse : warehouses.find((w) => Number(w.id) === Number(row.warehouse_id));
                let statusData = row.status_data ? row.status_data : statusList.find((s) => Number(s.id) === Number(row.status));
                return {
                    ...row,
                    warehouse: warehouseData || null,
                    status_data: statusData || null,
                    transaction_date_display: row.transaction_date_display ? row.transaction_date_display : (row.transaction_date ? row.transaction_date : "-"),
                };
            });

            setPoData(pre => ({
                ...pre,
                data : normalizedRows,
                metaData : metaData,
                totalListingCount: metaData && metaData.total ? metaData.total : 0
            }))
        }).then(() => setPoData(pre => ({...pre, loading : false})));
    };


    const addToIndentPrPo = (type) => {
        let key = "ticketAddToIndent"
        if(type === "pr") {
            key = "ticketAddToPr"
        }else if(type === "po") {
            key = "ticketAddToPo"
        }

        localStorage.setItem(key, JSON.stringify(ticketData));
    }   

  return (
    <>
    {
        settings && settings.ticket_warehouse_indent === "Y" &&
        <>
        <div className="tab_content_wrapper mt-2">
            <span className="content_heading">Warehouse Indent</span>
             {permissions.includes('isc-warehouse-indent-add') &&
            <span className="text-end">
                {ticketData &&
                    ticketData.status !== 0 && ticketData.ticket_for !== "site" &&
                <Link
                target="_blank"
                // disabled={!this.props.permissions.includes('isc-consumption-add')}
                to={{
                    pathname: "/warehouse_indent_add",
                    search: new URLSearchParams({
                        ticketId: ticketData.activity_id
                    }).toString(),
                }}
                onClick={() => addToIndentPrPo("indent")}
                >
                <TapIcon.FontAwesomeIcon
                    icon={TapIcon.faPlus}
                    alt="item-action"
                />
                </Link>
                }
            </span>
             } 
        </div>
        <table className="table table-hover table-bordered table-sm my-sm-2 mb-sm-4">
            {
                indentData.loading 
                ?
                <tr>
                    <td className="text-center" colSpan={9}><Loader/></td>
                </tr> 
                :
                indentData.data.length > 0 
                ?
                <>
                    <thead className="table-secondary" >
                        <tr className='text-center'>
                            <th scope="col" style={{ width: "5%" }}>S.No.</th>
                            <th scope="col" style={{ width: "10%" }}>Transaction ID</th>
                            <th scope="col" style={{ width: "15%" }}>Date of Transaction</th>
                            <th scope="col" style={{ width: "20%" }}>Warehouse</th>
                            <th scope="col" style={{ width: "20%" }}>Indent For</th>
                            <th scope="col" style={{ width: "10%" }}>Status</th>
                            <th scope="col" className="text-center" style={{ width: "10%" }}>Indent Qty</th>
                            <th scope="col" className="text-end" style={{ width: "10%" }}>Fullfilled Qty</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            indentData.data.map((d,i) => (
                                <tr key={d.transaction_id}>
                                    <td>{indentData.metaData ? indentData.metaData.from + i : i+1}</td>
                                    <td>{d.transaction_id}</td>
                                    <td>{d.transaction_date_display}</td>
                                    <td>{d.warehouse ? d.warehouse.name : ''}</td>
                                    <td>{d.assetProfile 
                                        ? <div><small className='form-text'>
                                        {d.indent_for == 'asset' ? 'Asset : ' : ''}</small> 
                                        {d.assetProfile.name} 
                                        </div>
                                        : 
                                        d.workstation 
                                        ?<div><small className='form-text'>
                                            {d.indent_for == 'workstation'?  'Workstation : ' : ''}
                                            </small>{d.workstation.workstation_name}</div> 
                                        : 
                                        d.employee 
                                        ?<div><small className='form-text'>
                                            {d.indent_for == 'employee' ?  'Employee : ' : ''}</small>
                                                {d.employee.name}  
                                            </div> 
                                        : ''  
                                        }
                                    </td>
                                    <td>{d.status_data ? d.status_data.name : ''}</td>
                                    <td className='text-end'>{d.total_qty}</td>
                                    <td className='text-end'>{d.fullfilled_qty}</td>
                                </tr>
                            ))
                        }
                    </tbody>
                </>
                :
                <tbody>
                    <tr>
                        <td className="text-center" colSpan={9}>No Records</td>
                    </tr>
                </tbody>
            }
        </table>
        {
            indentData.data.length > 0 && 
            <DisplayListPagination
            meta={indentData.metaData}
            onPageChange={(e) => getIndentList(e.selected + 1)
            }
            />
        }
        </>
    }
    {
        settings && settings.ticket_purchase_requisition === "Y" &&
        <>
        <div className="tab_content_wrapper mt-2">
            <span className="content_heading">Purchase Requisition</span>
                      {permissions.includes('isc-purchase-requisition-add') &&
                          <span className="text-end">
                              {ticketData &&
                                  ticketData.status !== 0 && ticketData.ticket_for !== "site" &&
                                  <Link
                                      target="_blank"
                                      // disabled={!this..permissions.includes('isc-consumption-add')}
                                      to={{
                                          pathname: "/requisition_list/add",
                                          search: new URLSearchParams({
                                              ticketId: ticketData.activity_id
                                          }).toString(),
                                      }}
                                      onClick={() => addToIndentPrPo("pr")}
                                  >
                                      <TapIcon.FontAwesomeIcon
                                          icon={TapIcon.faPlus}
                                          alt="item-action"
                                      />
                                  </Link>
                              }
                          </span>
                      }
        </div>
        <table className="table table-hover table-bordered table-sm my-sm-2 mb-sm-4">
            {
                prData.loading 
                ?
                <tr>
                    <td className="text-center" colSpan={9}><Loader/></td>
                </tr> 
                :
                prData.data.length > 0 
                ?
                <>
                    <thead className="table-secondary" >
                        <tr className='text-center'>
                            <th scope="col" style={{ width: "5%" }}>S.No.</th>
                            <th scope="col" style={{ width: "10%" }}>Transaction ID</th>
                            <th scope="col" style={{ width: "15%" }}>Date of Transaction</th>
                            <th scope="col" style={{ width: "20%" }}>Warehouse</th>
                            <th scope="col" style={{ width: "20%" }}>PR For</th>
                            <th scope="col" style={{ width: "10%" }}>Status</th>
                            <th scope="col" className="text-center" style={{ width: "10%" }}>Total Qty</th>
                            <th scope="col" className="text-end" style={{ width: "10%" }}>Total Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            prData.data.map((d,i) => (
                                <tr key={d.transaction_id}>
                                    <td>{prData.metaData ? prData.metaData.from + i : i+1}</td>
                                    <td>{d.transaction_id}</td>
                                    <td>{d.transaction_date_display}</td>
                                    <td>{d.warehouse ? d.warehouse.name : ''}</td>
                                    <td>{d.assetProfile 
                                        ? <div><small className='form-text'>
                                        {d.indent_for == 'asset' ? 'Asset : ' : ''}</small> 
                                        {d.assetProfile.name} 
                                        </div>
                                        : 
                                        d.workstation 
                                        ?<div><small className='form-text'>
                                            {d.indent_for == 'workstation'?  'Workstation : ' : ''}
                                            </small>{d.workstation.workstation_name}</div> 
                                        : 
                                        d.employee 
                                        ?<div><small className='form-text'>
                                            {d.indent_for == 'employee' ?  'Employee : ' : ''}</small>
                                                {d.employee.name}  
                                            </div> 
                                        : ''  
                                        }
                                    </td>
                                    <td>{d.status_data ? d.status_data.name : ''}</td>
                                    <td className='text-end'>{d.total_qty}</td>
                                    <td className='text-end'>{d.total_amount}</td>
                                </tr>
                            ))
                        }
                    </tbody>
                </>
                :
                <tbody>
                    <tr>
                        <td className="text-center" colSpan={9}>No Records</td>
                    </tr>
                </tbody>
            }
        </table>
        {
            prData.data.length > 0 && 
            <DisplayListPagination
            meta={prData.metaData}
            onPageChange={(e) => getIndentList(e.selected + 1)
            }
            />
        }
        </>
    }
    {
              settings && settings.ticket_purchase_order === "Y" &&
              <>
                  <div className="tab_content_wrapper mt-2">
                      <span className="content_heading">Purchase Order</span>
                      {permissions.includes('isc-po-add') &&

                          <span className="text-end">
                              {ticketData &&
                                  ticketData.status !== 0 && ticketData.ticket_for !== "site" &&
                                  <Link
                                      target="_blank"
                                      // disabled={!this.permissions.includes('isc-consumption-add')}
                                      to={{
                                          pathname: "/purchase_order/add",
                                          search: new URLSearchParams({
                                              ticketId: ticketData.activity_id
                                          }).toString(),
                                      }}
                                      onClick={() => addToIndentPrPo("po")}
                                  >
                                      <TapIcon.FontAwesomeIcon
                                          icon={TapIcon.faPlus}
                                          alt="item-action"
                                      />
                                  </Link>
                              }
                          </span>
                      }
        </div>
        <table className="table table-hover table-bordered table-sm my-sm-2 mb-sm-4">
            {
                poData.loading 
                ?
                <tr>
                    <td className="text-center" colSpan={9}><Loader/></td>
                </tr> 
                :
                poData.data.length > 0 
                ?
                <>
                    <thead className="table-secondary" >
                        <tr className='text-center'>
                            <th scope="col" style={{ width: "5%" }}>S.No.</th>
                            <th scope="col" style={{ width: "10%" }}>Transaction ID</th>
                            <th scope="col" style={{ width: "15%" }}>Date of Transaction</th>
                            <th scope="col" style={{ width: "20%" }}>Warehouse</th>
                            <th scope="col" style={{ width: "20%" }}>PO For</th>
                            <th scope="col" style={{ width: "10%" }}>Status</th>
                            <th scope="col" className="text-center" style={{ width: "10%" }}>Total Qty</th>
                            <th scope="col" className="text-end" style={{ width: "10%" }}>Total Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            poData.data.map((d,i) => (
                                <tr key={d.transaction_id}>
                                    <td>{poData.metaData ? poData.metaData.from + i : i+1}</td>
                                    <td>{d.transaction_id}</td>
                                    <td>{d.transaction_date_display}</td>
                                    <td>{d.warehouse ? d.warehouse.name : ''}</td>
                                    <td>{d.assetProfile 
                                        ? <div><small className='form-text'>
                                        {d.indent_for == 'asset' ? 'Asset : ' : ''}</small> 
                                        {d.assetProfile.name} 
                                        </div>
                                        : 
                                        d.workstation 
                                        ?<div><small className='form-text'>
                                            {d.indent_for == 'workstation'?  'Workstation : ' : ''}
                                            </small>{d.workstation.workstation_name}</div> 
                                        : 
                                        d.employee 
                                        ?<div><small className='form-text'>
                                            {d.indent_for == 'employee' ?  'Employee : ' : ''}</small>
                                                {d.employee.name}  
                                            </div> 
                                        : ''  
                                        }
                                    </td>
                                    <td>{d.status_data ? d.status_data.name : ''}</td>
                                    <td className='text-end'>{d.total_qty}</td>
                                    <td className='text-end'>{d.total_amount}</td>
                                </tr>
                            ))
                        }
                    </tbody>
                </>
                :
                <tbody>
                    <tr>
                        <td className="text-center" colSpan={9}>No Records</td>
                    </tr>
                </tbody>
            }
        </table>
        {
            poData.data.length > 0 && 
            <DisplayListPagination
            meta={poData.metaData}
            onPageChange={(e) => getIndentList(e.selected + 1)
            }
            />
        }
        </>
    }
        
    </>
  )
}

export default ProcurementTab